import { ReactElement } from 'react';

import {
  InputTypes,
  IntegrationThemes,
  PaymentFormField,
} from '@cashier/cashier-model';
import { useUIConfiguration } from '@cashier/cashier-shared';

import { useCashierConfiguration } from '../../hooks';
import { TextRow } from './textRow/v2';
import { UrlRow } from './urlRow/v2';
import { Button } from './button';
import { CopyableText } from './copyableText';
import { QrCode } from './qrCode';

interface InformationBlockContentWrapperProps {
  field: PaymentFormField;
  theme: IntegrationThemes;
}

export const InformationBlockContentWrapper = ({
  field,
  theme,
}: InformationBlockContentWrapperProps): ReactElement => {
  const { direction } = useCashierConfiguration();
  const copyableTextType = useUIConfiguration('copyableText', 'type');
  const qrCodeType = useUIConfiguration('qrCode', 'type');
  const qrCodeBehaviourType = useUIConfiguration('qrCode', 'behaviourType');

  switch (field.type) {
    case InputTypes.QrCode:
      return (
        <QrCode
          type={qrCodeType}
          behaviourType={qrCodeBehaviourType}
          value={field.value?.toString() || ''}
        />
      );

    case InputTypes.Url:
      return (
        <UrlRow
          label={field.label || ''}
          linkUrl={field.value as string}
          direction={direction}
        />
      );

    case InputTypes.Button:
      return (
        <Button
          label={field.label || ''}
          linkUrl={field.value?.toString() || ''}
        />
      );

    case InputTypes.CopyableText:
      return (
        <CopyableText
          name={field.name}
          text={field.value?.toString() || ''}
          label={field.label || ''}
          theme={theme}
          type={copyableTextType}
        />
      );

    default:
      return (
        <TextRow
          direction={direction}
          label={field.label || ''}
          value={field.value?.toString() || ''}
        />
      );
  }
};
